import { Typography } from 'antd';
import React from 'react';
import styled from 'styled-components';

import { margins } from '../commonProps';
import { IRaiseTextProps } from './RaiseText.types';

const {Text} = Typography;

const RaiseText = styled(
  ({
    marginLeft,
    marginRight,
    marginTop,
    marginBottom,
    margin,
    fontWeight,
    fontSize,
    color,
    textAlign,
    ...props
  }: IRaiseTextProps) => <Text {...props} />,
)`
  && {
    ${margins}
    font-family: 'Poppins', sans-serif;
    font-weight: ${({fontWeight}) => fontWeight || 'normal'};
    font-size: ${({fontSize}) => fontSize || '16px'};
    color: ${({color}) => color || '#262626'};
    ${({textAlign}) => textAlign && `text-align: ${textAlign};`}
  }
`;

export default RaiseText;
